import Vue from 'vue'
import Vuex from 'vuex'
import se from './modules/se'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    se,
  },
  strict: debug
})
